import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitter"];

  submit() {
    this.element.requestSubmit();
  }

  submitWith() {
    this.element.requestSubmit(this.submitterTarget);
  }
}
